'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _class;

var _reactSelect = require('react-select');

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _reactSelectFastFilterOptions = require('react-select-fast-filter-options');

var _reactSelectFastFilterOptions2 = _interopRequireDefault(_reactSelectFastFilterOptions);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _apiHelper = require('api/api-helper');

var _forms = require('metadata/forms');

var _reactIntl = require('react-intl');

var _pacomo = require('utils/pacomo');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    SelectCachedInput: {
        displayName: 'SelectCachedInput'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/Users/gareth.chou/Documents/GAdventures/g-rex/app/components/forms/SelectCachedInput.js',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

// Used to render a Select that can asynchronous search resources from G-API, store/cache the results
// and be able to re-request results if the base input Field's value has changed
var SelectCachedInput = _wrapComponent('SelectCachedInput')((0, _reactIntl.injectIntl)(_class = (0, _pacomo.pacomoDecorator)(_class = function (_React$Component) {
    (0, _inherits3.default)(SelectCachedInput, _React$Component);

    function SelectCachedInput(props) {
        (0, _classCallCheck3.default)(this, SelectCachedInput);

        var _this = (0, _possibleConstructorReturn3.default)(this, (SelectCachedInput.__proto__ || (0, _getPrototypeOf2.default)(SelectCachedInput)).call(this, props));

        _this.state = {
            options: [],
            value: _this.props.input.value || '',
            isLoading: false
        };

        _this.getOptionsAsync = _this.getOptionsAsync.bind(_this);

        if (!(typeof _this.getOptionsAsync === 'function')) {
            throw new TypeError('Value of "this.getOptionsAsync" violates contract.\n\nExpected:\n(any) => any\n\nGot:\n' + _inspect(_this.getOptionsAsync));
        }

        _this.sendEmpty = _this.sendEmpty.bind(_this);

        if (!(typeof _this.sendEmpty === 'function')) {
            throw new TypeError('Value of "this.sendEmpty" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(_this.sendEmpty));
        }

        return _this;
    }

    // Implemented to display an empty list in the Select
    // Specifically used when the user clicks the 'x'


    (0, _createClass3.default)(SelectCachedInput, [{
        key: 'sendEmpty',
        value: function sendEmpty() {
            this.setState({
                options: [],
                value: '',
                isLoading: false
            });
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps, nextState) {
            if (nextProps.input.value !== this.props.input.value) {
                if (nextProps.input.value) {
                    this.getOptionsAsync({ inputValue: nextProps.input.value });
                } else {
                    this.sendEmpty();
                }
            }
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            if (this.props.input.value) {
                this.getOptionsAsync({ inputValue: this.props.input.value });
            }
        }

        // Calls the API and shoves the returned options
        // into the component state

    }, {
        key: 'getOptionsAsync',
        value: function getOptionsAsync(_ref) {
            var _this2 = this;

            var inputValue = _ref.inputValue,
                _ref$fuzzy = _ref.fuzzy,
                fuzzy = _ref$fuzzy === undefined ? false : _ref$fuzzy,
                _ref$searchParams = _ref.searchParams,
                searchParams = _ref$searchParams === undefined ? false : _ref$searchParams;
            var _props = this.props,
                queryParam = _props.queryParam,
                loadResource = _props.loadResource,
                resultParsing = _props.resultParsing,
                fuzzyParam = _props.fuzzyParam;

            var resultParsingFunc = resultParsing || function (results) {
                return results.filter(function (result) {
                    return result.id;
                }).map(function (result) {
                    return {
                        label: '' + result.name,
                        value: result.id
                    };
                });
            };
            this.setState({ isLoading: true });
            if (inputValue) {
                (0, _apiHelper.loadOptions)({
                    input: inputValue,
                    resource: loadResource,
                    queryParam: queryParam,
                    searchParams: searchParams,
                    fuzzyParam: fuzzyParam,
                    fuzzy: fuzzy
                }).then(function (_ref2) {
                    var results = _ref2.results,
                        error = _ref2.error;

                    _this2.setState({
                        options: results ? resultParsingFunc(fuzzy || queryParam ? results : [results]) : [],
                        value: inputValue,
                        isLoading: false
                    });
                }).catch(function (error) {
                    console.error(error);
                });
            }
        }
    }, {
        key: 'onInputChange',
        value: function onInputChange(option) {
            var searchParams = this.props.searchParams;

            var options = {};

            if (option) {
                options.inputValue = option;
                options.fuzzy = true;
            } else {
                options.inputValue = this.props.input.value;
                options.fuzzy = false;
            }
            if (searchParams) {
                var filteredParams = searchParams.filter(function (pair) {
                    return pair.value;
                });
                if (filteredParams.length) {
                    options.searchParams = filteredParams;
                }
            }
            if (option) {
                this.getOptionsAsync(options);
            }
        }
    }, {
        key: 'onChange',
        value: function onChange(option) {
            var input = this.props.input;

            this.setState({ value: option ? option.value : '' });
            return input.onChange(option ? option.value : '');
        }
    }, {
        key: 'onBlur',
        value: function onBlur() {
            var input = this.props.input;

            return input.onBlur(input.value);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                id = _props2.id,
                placeholder = _props2.placeholder,
                input = _props2.input,
                intl = _props2.intl,
                name = _props2.name,
                requirement = _props2.requirement,
                _props2$meta = _props2.meta,
                touched = _props2$meta.touched,
                error = _props2$meta.error;
            var _state = this.state,
                options = _state.options,
                isLoadingExternally = _state.isLoadingExternally;


            var inputProps = {
                id: id,
                name: name,
                disabled: requirement && !requirement.editable
            };

            var selectProps = (0, _extends3.default)({}, inputProps, {
                placeholder: placeholder || intl.formatMessage(_forms.formPlaceholders.searchPrompt),
                searchPrompText: intl.formatMessage(_forms.formPlaceholders.searchPrompt),
                searchingText: intl.formatMessage(_forms.formPlaceholders.searching),
                noResultsText: intl.formatMessage(_forms.formPlaceholders.noResultsText),
                onChange: this.onChange.bind(this),
                onBlur: this.onBlur.bind(this),
                onInputChange: _lodash2.default.debounce(this.onInputChange.bind(this), 500),
                value: this.props.input.value,
                filterOption: (0, _reactSelectFastFilterOptions2.default)({ options: options }),
                options: options,
                isLoading: isLoadingExternally
            });

            return _react3.default.createElement(
                'div',
                null,
                _react3.default.createElement(_reactSelect2.default, selectProps)
            );
        }
    }]);
    return SelectCachedInput;
}(_react3.default.Component)) || _class) || _class);

exports.default = SelectCachedInput;

function _inspect(input, depth) {
    var maxDepth = 4;
    var maxKeys = 15;

    if (depth === undefined) {
        depth = 0;
    }

    depth += 1;

    if (input === null) {
        return 'null';
    } else if (input === undefined) {
        return 'void';
    } else if (typeof input === 'string' || typeof input === 'number' || typeof input === 'boolean') {
        return typeof input === 'undefined' ? 'undefined' : (0, _typeof3.default)(input);
    } else if (Array.isArray(input)) {
        if (input.length > 0) {
            if (depth > maxDepth) return '[...]';

            var first = _inspect(input[0], depth);

            if (input.every(function (item) {
                return _inspect(item, depth) === first;
            })) {
                return first.trim() + '[]';
            } else {
                return '[' + input.slice(0, maxKeys).map(function (item) {
                    return _inspect(item, depth);
                }).join(', ') + (input.length >= maxKeys ? ', ...' : '') + ']';
            }
        } else {
            return 'Array';
        }
    } else {
        var keys = (0, _keys2.default)(input);

        if (!keys.length) {
            if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
                return input.constructor.name;
            } else {
                return 'Object';
            }
        }

        if (depth > maxDepth) return '{...}';
        var indent = '  '.repeat(depth - 1);
        var entries = keys.slice(0, maxKeys).map(function (key) {
            return (/^([A-Z_$][A-Z0-9_$]*)$/i.test(key) ? key : (0, _stringify2.default)(key)) + ': ' + _inspect(input[key], depth) + ';';
        }).join('\n  ' + indent);

        if (keys.length >= maxKeys) {
            entries += '\n  ' + indent + '...';
        }

        if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
            return input.constructor.name + ' {\n  ' + indent + entries + '\n' + indent + '}';
        } else {
            return '{\n  ' + indent + entries + '\n' + indent + '}';
        }
    }
}

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/components/forms/SelectCachedInput.js
// module id = 1348
// module chunks = 0